import React, { useContext, useState, useEffect } from 'react';
import { Modal, Form } from 'react-bootstrap';
import toast from 'react-hot-toast';

import { DataContext } from '../../../init/getData';
import { Space, Table, Tag, Button } from 'antd';

import { numberFormatter } from '../../../components/formatters/numberFormatter';




const LoadStockControlJv = (props) => {

    const { setTransactions, journalVoucher, cart, totalCost, selectedCurrency } = props;

    const { api, userData, settingData, mainCurrency, rateFromToCurrency, rateMainToSecondaryCurrency, rateToMainCurrency } = useContext(DataContext);
    const userId = userData.id;
    const userName = userData.name;
    const userRole = userData.role;



    // load Transactions
    useEffect(() => {
        loadJV();
    }, [journalVoucher, cart]);

    const accountId = journalVoucher?.accountId;
    const warehouseId = journalVoucher?.warehouseId;
    const cashAccountId = userRole.cashAccountId;

    const stockControlAccountId = settingData.stockControlAccountId;
    const isDebit = journalVoucher.isDebit;

    const downPayment = journalVoucher.downPayment;

    const rate = selectedCurrency?.rate;
    const currencyId = selectedCurrency?.id;

    console.log(stockControlAccountId)


    const loadJV = () => {

        let updatedTransactions = [];

        updatedTransactions = loadStockTansaction(updatedTransactions, isDebit, stockControlAccountId, 'StockControl', totalCost, warehouseId)
        updatedTransactions = loadAcountTransaction(updatedTransactions, !isDebit, stockControlAccountId, 'StockControl', totalCost);

        setTransactions(updatedTransactions)

    }



    const loadStockTansaction = (updatedTransactions, isDebit, accountId, type, total, warehouseId) => {

        const debit = isDebit ? total : 0;
        const credit = !isDebit ? total : 0;

        const totalDebit = rateToMainCurrency(selectedCurrency, debit);
        const totalCredit = rateToMainCurrency(selectedCurrency, credit);

        const secondaryTotalDebit = rateMainToSecondaryCurrency(totalDebit);
        const secondaryTotalCredit = rateMainToSecondaryCurrency(totalCredit);

        const cartTransaction = {
            type: type,
            accountId: accountId,
            details: '',
            isDebit: isDebit,
            debit: debit,
            credit: credit,
            totalDebit: totalDebit,
            totalCredit: totalCredit,
            secondaryTotalDebit: secondaryTotalDebit,
            secondaryTotalCredit: secondaryTotalCredit,
            currencyId: currencyId,
            rate: rate,
            haveCart: true,
            warehouseId: warehouseId,
        }

        updatedTransactions.push(cartTransaction);
        return updatedTransactions;
    };


    const loadAcountTransaction = (updatedTransactions, isDebit, accountId, type, total) => {


        const debit = isDebit ? total : 0;
        const credit = !isDebit ? total : 0;

        const totalDebit = rateToMainCurrency(selectedCurrency, debit);
        const totalCredit = rateToMainCurrency(selectedCurrency, credit);

        const secondaryTotalDebit = rateMainToSecondaryCurrency(totalDebit);
        const secondaryTotalCredit = rateMainToSecondaryCurrency(totalCredit);

        const accountTransaction = {
            type: type,
            accountId: accountId,
            details: '',
            isDebit: isDebit,
            debit: debit,
            credit: credit,
            totalDebit: totalDebit,
            totalCredit: totalCredit,
            secondaryTotalDebit: secondaryTotalDebit,
            secondaryTotalCredit: secondaryTotalCredit,
            currencyId: currencyId,
            rate: rate,
        }

        updatedTransactions.push(accountTransaction);

        return updatedTransactions;
    }

    return (


        <></>

    )
}


export default LoadStockControlJv;